import React from "react";
import Styled, { css } from "styled-components";

import { ITheme } from "../../interface";
import { useTheme } from "../../context/ThemeProvider";
import { aboutMe, screenSize } from "../../constant";
const { maxWidth } = screenSize;

const AboutMeContainer = Styled.div`
    height: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20vh;
    @media screen and (max-width: ${maxWidth.mediumPhoneV2}) {
        margin-bottom: 5vh;
    }
`;

const TextWrapper = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: -20%;
    position: relative;
}
`;

const Title = Styled.h2<{ $props: { showAboutMe: boolean } }>`
    ${({ $props }) => {
      const { showAboutMe } = $props;

      return css`
        transform: translateY(${showAboutMe ? 0 : 150}%);
        opacity: ${showAboutMe ? 1 : 0};
      `;
    }}
    transition: all 0.4s ease-in-out 0s;
    width: max-content;
    font-size: 2em;
    margin: 0;
    @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
      font-size: 1.5em;
    }
`;
const Highlight = Styled.span<{ $props: { colorTheme: ITheme["colors"] } }>`
    transition: all 0.4s ease-in-out 0s;
    ${({ $props }) => {
      const { colorTheme } = $props;

      return css`
        color: ${colorTheme.hightlightFont};
      `;
    }}
`;

const AboutMeText = Styled.p<{
  $props: { theme: ITheme; showAboutMe: boolean };
}>`
    width: 100%;
    text-align: justify;
    padding: 2vw 1.5vw;
    border-radius: 5px;
    transition: all 0.4s ease-in-out 0s;

    font-size: 15px;
    line-height: 20px;
    @media screen and (max-width: ${maxWidth.mediumPhoneV2}) {
        font-size: 12px;
        line-height: 15px;
        width: 92.5vw;
    }

    ${({ $props }) => {
      const { theme, showAboutMe } = $props;
      return css`
        color: ${theme.colors.font};
        background: ${theme.colors.primary};
        transform: translateY(${showAboutMe ? 0 : 150}%);
        opacity: ${showAboutMe ? 1 : 0};
        box-shadow: ${theme.colors.tertiary} 0px 1px 0px,
          ${theme.colors.tertiary} 0px 0px 8px;
      `;
    }}
`;

function MoreAboutMe({ showAboutMe }: { showAboutMe: boolean }) {
  const { theme, oppositeTheme } = useTheme();

  return (
    <AboutMeContainer>
      <TextWrapper>
        <Title $props={{ showAboutMe }}>
          More{" "}
          <Highlight $props={{ colorTheme: theme.colors }}>About Me</Highlight>
        </Title>
        <AboutMeText $props={{ theme: oppositeTheme, showAboutMe }}>
          {aboutMe.long}
        </AboutMeText>
      </TextWrapper>
    </AboutMeContainer>
  );
}

export default MoreAboutMe;
